import { computed, state } from 'ccstate'
import { apiClient$ } from '../infra/apiClient'

export const searchQuery$ = state('')

export const searchSuggestions$ = computed(async (get) => {
  const query = get(searchQuery$)

  if (!query.trim()) {
    return []
  }

  const apiClient = get(apiClient$)
  const result = await apiClient.getApi('searchWord', { query })
  return result.suggestions
})
